import React from "react";
import "./App.css";
import TicketsPage from "./pages/TicketsPage";
import ProblemsPage from "./pages/ProblemsPage";
import AssetsPage from "./pages/AssetsPage";
import ChangesPage from "./pages/ChangesPage";
import Health from "./components/Health";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from '@material-ui/core/styles'
import { AuthProvider } from "./services/authService";
import orange from "@material-ui/core/colors/orange";
import usePersistedState from "./hooks/usePersistedState";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";

const darkTheme = createTheme({
    palette: {
        type: "dark",
        secondary: orange,
        background: {
            default: "#2f2d2d",
            paper: "#3e3c3c"
        }
    }
});

const lightTheme = createTheme({
    palette: {
        secondary: orange
    }
});

const App = () => {
    const [darkMode, setDarkMode] = usePersistedState(false, "dark-mode");

    return (
        <Router>
            <Switch>
            <Route exact path="/">
                    <AuthProvider>
                        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
                            <TicketsPage setDarkMode={setDarkMode} darkMode={darkMode} />
                        </ThemeProvider>
                    </AuthProvider>
                </Route>
                <Route path="/Problems">
                    <AuthProvider>
                        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
                            <ProblemsPage setDarkMode={setDarkMode} darkMode={darkMode} />
                        </ThemeProvider>
                    </AuthProvider>
                </Route>
                <Route path="/Assets">
                    <AuthProvider>
                        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
                            <AssetsPage setDarkMode={setDarkMode} darkMode={darkMode} />
                        </ThemeProvider>
                    </AuthProvider>
                </Route>
                <Route path="/Changes">
                    <AuthProvider>
                        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
                            <ChangesPage setDarkMode={setDarkMode} darkMode={darkMode} />
                        </ThemeProvider>
                    </AuthProvider>
                </Route>
                  <Route path="/Dashboard">
                    <AuthProvider>
                        <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
                            <DashboardPage setDarkMode={setDarkMode} darkMode={darkMode} />
                        </ThemeProvider>
                    </AuthProvider>
                </Route>
                <Route path="/health"><Health /></Route>
            </Switch>
        </Router>
    ); 
};

export default App;
